import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown as AntdDropdown, } from 'antd';
import { memo, useCallback, useEffect, useMemo, useState, } from 'react';
import { useTheme } from 'styled-components';
import { Divider } from '../../components/Divider';
import { Panel } from '../../components/Panel';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { StyledCustomDropdownItemWrapper, StyledDropDownMenu, StyledMenuItemCenterWrapper, StyledMenuItemSideWrapper, StyledMenuItemWrapper, } from './DropdownNext.style';
export const DropdownOption = memo(function DropdownOption({ variant, disabled, value, label, extra, icon, children, onClick, }) {
    var _a;
    const theme = useTheme();
    const color = useMemo(() => {
        if (disabled) {
            return theme.Color.Neutrals.Gray;
        }
        if (variant === 'selected') {
            return theme.Color.Brand.Primary;
        }
        return theme.Color.Neutrals.Dark;
    }, [theme, variant, disabled]);
    return (_jsxs(StyledMenuItemWrapper, { variant: variant, disabled: disabled, onClick: (event) => onClick === null || onClick === void 0 ? void 0 : onClick(value, event), children: [icon && (_jsx(Icon, { color: (_a = icon.color) !== null && _a !== void 0 ? _a : color, name: icon.name, size: 'XSmall' })), _jsx(StyledMenuItemCenterWrapper, { children: _jsx(Text, { size: 'Body', color: color, children: label }) }), extra && _jsx(StyledMenuItemSideWrapper, { children: extra }), children && (_jsx(StyledMenuItemSideWrapper, { children: _jsx(Icon, { name: 'editor-chevron-right', color: color, size: 'XXSmall' }) }))] }));
});
export function DropdownItem({ variant = 'default', disabled, value, label, extra, icon, onClick, children, }) {
    if (Array.isArray(children)) {
        return (_jsx(DropdownNext, { placement: 'rightTop', options: children, trigger: 'hover', children: _jsx("div", { children: _jsx(DropdownOption, { variant: variant, disabled: disabled, label: label, value: value, extra: extra, icon: icon, children: children, onClick: (value, event) => {
                        event === null || event === void 0 ? void 0 : event.preventDefault();
                        onClick === null || onClick === void 0 ? void 0 : onClick(value, event);
                    } }) }) }));
    }
    return (_jsx(DropdownOption, { variant: variant, disabled: disabled, label: label, value: value, extra: extra, icon: icon, onClick: onClick }));
}
export function DropdownNext({ placement, children, options, fixedHeight, trigger = 'click', onClick, state: stateProps, onOpenChange: onOpenChangeProp, isClosedOnSelect = false, }) {
    const [isOpen, setIsOpen] = useState(!!(stateProps === null || stateProps === void 0 ? void 0 : stateProps.open));
    useEffect(() => {
        if ((stateProps === null || stateProps === void 0 ? void 0 : stateProps.open) !== undefined) {
            setIsOpen(stateProps.open);
        }
    }, [stateProps]);
    const onOpenChange = useCallback((open) => {
        setIsOpen(open);
        onOpenChangeProp === null || onOpenChangeProp === void 0 ? void 0 : onOpenChangeProp(open);
    }, [onOpenChangeProp]);
    const handleClick = useCallback((value) => {
        isClosedOnSelect && onOpenChange(false);
        onClick === null || onClick === void 0 ? void 0 : onClick(value);
    }, [onClick, isClosedOnSelect, onOpenChange]);
    return (_jsx(AntdDropdown, { open: isOpen, onOpenChange: onOpenChange, placement: placement, trigger: [trigger], dropdownRender: () => (_jsx(Panel, { variant: "float", children: _jsx(Panel.Content, { children: _jsx(StyledDropDownMenu, { fixedHeight: fixedHeight, children: options.map((item, index) => {
                        switch (item.type) {
                            case 'divider':
                                return _jsx(Divider, {}, `dropdown-option-divider-${index}`);
                            case 'custom':
                                return (_jsx(StyledCustomDropdownItemWrapper, { onClick: handleClick.bind(null, item.value), children: item.children }, `dropdown-option-${item.value}-${index}`));
                            default:
                                return (_jsx(DropdownItem, Object.assign({ onClick: handleClick }, item), `dropdown-option-${item.value}-${index}`));
                        }
                    }) }) }) })), children: children }));
}
//# sourceMappingURL=DropdownNext.js.map